import React from "react"
import { Radium } from "higher-order-components"
import PropTypes from "prop-types"
import { titleCase, compact, compactMap } from "utils"
import { Hyperlink } from "components"

const fullAddress = location => {
  const {
    address, suburb, state, postCode
  } = location
  const region = compact([state, postCode]).join(" ")
  return compactMap(titleCase, [address, suburb])
    .concat(region || [])
    .join(", ")
}

class DealerDetails extends React.PureComponent {
  render() {
    const { location, type, gtmEvents } = this.props
    const department = location.departments.find(
      department => department.name.toLowerCase() === type
    )

    return (
      <div style={{ marginBottom: "2em" }}>
        <strong>{location.name}</strong>
        <ul style={{ padding: 0, margin: "0", listStyleType: "none" }}>
          <li style={[dealerDetailStyles.detailItem, dealerDetailStyles.fadeIn]}>
            <div>
              <Hyperlink
                text={fullAddress(this.props.location)}
                href={`https://google.com.au/maps?q=${fullAddress(this.props.location).replace(
                  / /g,
                  "+"
                )}/`}
                external />
            </div>
          </li>
          <li style={[dealerDetailStyles.detailItem, dealerDetailStyles.fadeIn]}>
            <div>
              <strong>Opening hours:</strong>
              {department.hours.map((label, index) => <div key={index}>{label}</div>)}
            </div>
          </li>
        </ul>
      </div>
    )
  }
}

export default Radium(DealerDetails)

DealerDetails.propTypes = {
  location: PropTypes.object,
  type: PropTypes.string,
  gtmEvents: PropTypes.array
}

const dealerDetailStyles = {
  detailItem: {
    fontWeight: 200,
    margin: "0 0 0.5em",
    lineHeight: "1.4"
  }
}



// WEBPACK FOOTER //
// ./src/components/mymazda/dealer/details.jsx